import { Container } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { ECommerce, Product } from "../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import ProductFeatures from "./ProductFeatures/ProductFeatures";
import { useEffect } from "react";
import { fetchProductApiData } from "../../../../ReduxToolkit/Reducers/ECommerce/ProductSlice";
import ProductGrid from "./ProductGrid/ProductGrid";

const ProductContainer = () => {
  const sideBarOn = useAppSelector((state) => state.filterData.sideBarOn);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
  }, [dispatch]);
  return (
    <>
      <Breadcrumbs mainTitle={Product} parent={ECommerce} />
      <Container fluid className={`product-wrapper ${sideBarOn ? "sidebaron" : ""}`}>
        <div className="product-grid">
          <ProductFeatures />
          <ProductGrid />
        </div>
      </Container>
    </>
  );
};

export default ProductContainer;
